import type { SurfDeck } from "@vida/surf-core";
import { SlideThumb } from "./SlideThumb";

type Props = {
  deck: SurfDeck;
  slideIndex: number;
  slideBackgroundUrls: Record<string, string>;
  layerImageUrls?: Record<string, string>;
  onSelectSlide: (index: number) => void;
  onClose: () => void;
  onMoveSlide?: (from: number, to: number) => void;
};

export function DeckOverview({
  deck,
  slideIndex,
  slideBackgroundUrls,
  layerImageUrls = {},
  onSelectSlide,
  onClose,
  onMoveSlide,
}: Props) {
  return (
    <div className="deck-overview" role="dialog" aria-modal="true" aria-label="Panoramica deck">
      <div className="deck-overview-backdrop" onClick={onClose} aria-hidden />
      <div className="deck-overview-panel">
        <header className="deck-overview-head">
          <h2>Panoramica deck</h2>
          <button type="button" className="surf-icon-btn" aria-label="Chiudi" onClick={onClose}>
            ×
          </button>
        </header>
        <div className="deck-overview-grid">
          {deck.slides.map((slide, i) => (
            <div key={slide.id} className="deck-overview-cell">
              <SlideThumb
                deck={deck}
                slide={slide}
                slideIndex={i}
                slideBackgroundUrl={slideBackgroundUrls[slide.id]}
                layerImageUrls={layerImageUrls}
                active={i === slideIndex}
                onClick={() => {
                  onSelectSlide(i);
                  onClose();
                }}
              />
              {onMoveSlide && (
                <div className="deck-overview-reorder">
                  <button
                    type="button"
                    className="surf-icon-btn"
                    aria-label={`Sposta slide ${i + 1} su`}
                    disabled={i === 0}
                    onClick={() => onMoveSlide(i, i - 1)}
                  >
                    ↑
                  </button>
                  <button
                    type="button"
                    className="surf-icon-btn"
                    aria-label={`Sposta slide ${i + 1} giù`}
                    disabled={i === deck.slides.length - 1}
                    onClick={() => onMoveSlide(i, i + 1)}
                  >
                    ↓
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
